export default __webpack_public_path__ + "static/media/airdrop-events-empty.8e1fa71b.png";